module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 285);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initQiyuKF; });
/* harmony import */ var _http_header_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52);
/* harmony import */ var _tools_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
// 初始化客服


function initQiyuKF() {
  let cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let login = arguments.length > 1 ? arguments[1] : undefined;
  window.ysf = window.ysf || function () {
    (window.ysf.a = window.ysf.a || []).push([window, document, "ysf"]);
  };
  const temp = document.createElement("script");
  temp.async = true;
  temp.src = "https://qiyukf.com/script/24ada582654049dffe310a772b0c0db1.js?hidden=1";
  const miniApp = Object(_tools_js__WEBPACK_IMPORTED_MODULE_1__[/* isWxMiniApp */ "h"])();
  if (!miniApp) {
    document.body.appendChild(temp);
  }
  if (login) {
    setTimeout(() => {
      Object(_http_header_index_js__WEBPACK_IMPORTED_MODULE_0__[/* getUserInfo */ "c"])().then(res => {
        if (res.status == 200 && res.status_code == 1 && res.data && res.data.id) {
          setYsfUser(res.data, cb);
        } else {
          setYsfUser(null, cb);
        }
      }).catch(e => {
        setYsfUser(null, cb);
      });
    }, 1500);
  }
}
function setYsfUser() {
  let userInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  let cb = arguments.length > 1 ? arguments[1] : undefined;
  let ysfParams = {};
  const userId = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || getCookie("_za");
  if (userId) {
    ysfParams = {
      uid: userId,
      data: JSON.stringify([{
        key: "real_name",
        value: userId
      }])
    };
  }
  window.ysf && window.ysf("config", ysfParams);
  cb && cb(ysfParams);
}
function getCookie(c_name) {
  if (document.cookie.length > 0) {
    let c_start = document.cookie.indexOf(`${c_name}=`);
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      let c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) c_end = document.cookie.length;
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}

/***/ }),

/***/ 192:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui/lib/tooltip");

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui/lib/theme-chalk/tooltip.css");

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/common-footer/src/index.vue?vue&type=template&id=42163b76&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [{ "pc-common-footer-root": !_vm.isMobile && !_vm.isMobileEnd }],
      attrs: { id: "common-footer" }
    },
    [
      !_vm.isMobile && !_vm.isMobileEnd
        ? _c("div", { staticClass: "pc-common-footer" }, [
            _c(
              "div",
              { staticClass: "top-part" },
              [
                _vm._l(_vm.pcConfigOne, function(item) {
                  return _c(
                    "div",
                    { key: item.key, staticClass: "every-col" },
                    [
                      _c("p", { staticClass: "every-col-title" }, [
                        _vm._v(_vm._s(item.text))
                      ]),
                      _vm._v(" "),
                      _vm._l(item.subMenu, function(subItem, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "every-tab" },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: subItem.href,
                                  target: subItem.target || ""
                                }
                              },
                              [_vm._v(_vm._s(subItem.text))]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "right-kefu" }, [
                  _c("p", { staticClass: "bold" }, [_vm._v("联系我们")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "online-service",
                      on: { click: _vm.gotoQiyu }
                    },
                    [
                      _c("i", { staticClass: "kefu-icon" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("在线客服")])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "service-li service-email" }, [
                    _vm._v(
                      "\n                    客服邮箱 wenjuan@idiaoyan.com\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(1)
                ]),
                _vm._v(" "),
                _vm._l(_vm.pcConfigTwo, function(item) {
                  return _c(
                    "div",
                    { key: item.key, staticClass: "every-col" },
                    [
                      _c("p", { staticClass: "every-col-title" }, [
                        _vm._v(_vm._s(item.text))
                      ]),
                      _vm._v(" "),
                      _vm._l(item.subMenu, function(subItem, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "every-tab" },
                          [
                            subItem.type !== "tooltips"
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: subItem.href,
                                      target: subItem.target || ""
                                    }
                                  },
                                  [_vm._v(_vm._s(subItem.text))]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "mock-a",
                                    attrs: { target: subItem.target || "" }
                                  },
                                  [
                                    _c("span", [_vm._v(_vm._s(subItem.text))]),
                                    _vm._v(" "),
                                    _vm._m(2, true)
                                  ]
                                )
                          ]
                        )
                      })
                    ],
                    2
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "bottom-part" }, [
              _c("div", { staticClass: "split-line" }),
              _vm._v(" "),
              _c("div", { staticClass: "copyright" }, [
                _c("div", { staticClass: "line" }, [
                  _c("a", { attrs: { href: "/register/protocol/" } }, [
                    _vm._v("服务协议    ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    { attrs: { href: "/about/ystk/", target: "_blank" } },
                    [_vm._v("隐私政策    ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    { attrs: { href: "/about/disclaimer/", target: "_blank" } },
                    [_vm._v("免责声明    ")]
                  ),
                  _vm._v(
                    "\n                    ©2013-" +
                      _vm._s(_vm.currentYear) +
                      "\n                    上海众言网络科技有限公司    \n                    ICP证：合字B2-20220130    \n                    "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://beian.miit.gov.cn/",
                        target: "_blank"
                      }
                    },
                    [_vm._v("沪ICP备10013448号-25")]
                  ),
                  _vm._v("    \n                    "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402000149",
                        target: "_blank"
                      }
                    },
                    [_vm._v("沪公网安备31010402000149号")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "line" },
                  [
                    _c("span", [_vm._v("举报电话：4006-700-778    ")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      { attrs: { href: "mailto:wenjuan@idiaoyan.com" } },
                      [_vm._v("举报邮箱：wenjuan@idiaoyan.com    ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.wenjuan.com/s/UZBZJvya9/",
                          target: "_blank"
                        }
                      },
                      [_vm._v("举报表单    ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "http://www.shjbzx.cn/",
                          target: "_blank"
                        }
                      },
                      [_vm._v("上海市互联网违法和不良信息举报中心    ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "wj-tooltip",
                      { attrs: { placement: "top", effect: "light" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "text-align": "center",
                              "line-height": "18px"
                            },
                            attrs: { slot: "content" },
                            slot: "content"
                          },
                          [
                            _vm._v(
                              "\n                            全国扫黑除恶举报网站"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                            www.12389.gov.cn"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                            全国扫黑除恶举报电话：010-12389"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                            上海市扫黑除恶举报电话：021-52397077\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("a", { attrs: { href: "javascript:void(0);" } }, [
                          _vm._v("扫黑除恶举报")
                        ])
                      ]
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        : _c("div", { staticClass: "mobile-common-footer" }, [
            _c(
              "div",
              { staticClass: "top-part" },
              [
                _vm._l(_vm.mobileConfig, function(item) {
                  return _c(
                    "div",
                    {
                      key: item.key,
                      staticClass: "every-col",
                      class: [
                        { "company-col": item.key === "company" },
                        { "enterprise-col": item.key === "enterprise" },
                        { "resource-col": item.key === "resource" }
                      ]
                    },
                    [
                      _c("p", { staticClass: "every-col-title" }, [
                        _vm._v(_vm._s(item.text))
                      ]),
                      _vm._v(" "),
                      _vm._l(item.subMenu, function(subItem, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "every-tab" },
                          [
                            subItem.type !== "tooltips"
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: subItem.href,
                                      target: subItem.target || ""
                                    }
                                  },
                                  [_vm._v(_vm._s(subItem.text))]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "mock-a",
                                    attrs: { target: subItem.target || "" }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { id: "trigger-tooltips" },
                                        on: { click: _vm.showTooltip }
                                      },
                                      [_vm._v(_vm._s(subItem.text))]
                                    ),
                                    _vm._v(" "),
                                    _vm._m(3, true)
                                  ]
                                )
                          ]
                        )
                      })
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "right-kefu" }, [
                  _c("p", { staticClass: "bold" }, [_vm._v("联系我们")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "online-service",
                      on: { click: _vm.gotoQiyu }
                    },
                    [
                      _c("i", { staticClass: "kefu-icon" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("在线客服")])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(4),
                  _vm._v(" "),
                  _c("div", { staticClass: "service-li service-email" }, [
                    _vm._v(
                      "\n                    客服邮箱 wenjuan@idiaoyan.com\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(5)
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "bottom-part" }, [
              _c("div", { staticClass: "split-line" }),
              _vm._v(" "),
              _c("div", { staticClass: "copyright" }, [
                _c("div", { staticClass: "mobile-line" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c("div", { staticClass: "line" }, [
                    _vm._v(
                      "\n                        ©2013-" +
                        _vm._s(_vm.currentYear) +
                        " 上海众言网络科技有限公司\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(7),
                _vm._v(" "),
                _vm._m(8)
              ])
            ])
          ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "service-li service-phone" }, [
      _vm._v("\n                    客服专线 "),
      _c("span", { staticClass: "bold" }, [_vm._v("4006-700-778")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "service-li official-account" }, [
      _c("div", { staticClass: "qr-code" }),
      _vm._v(" "),
      _c("p", [_vm._v("问卷网公众号")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mock-tooltips" }, [
      _c("div", { staticClass: "contact-wechat" }),
      _vm._v(" "),
      _c("p", { staticClass: "tooltips-bottom-word" }, [
        _vm._v(
          "\n                                微信扫码联系销售\n                            "
        )
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "mock-tooltips",
        attrs: { id: "moible-footer-ad-cooperation" }
      },
      [
        _c("div", { staticClass: "contact-wechat" }),
        _vm._v(" "),
        _c("p", { staticClass: "tooltips-bottom-word" }, [
          _vm._v(
            "\n                                微信扫码联系销售\n                            "
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "service-li service-phone" }, [
      _vm._v("\n                    客服专线 "),
      _c("span", { staticClass: "bold" }, [_vm._v("4006-700-778")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "service-li official-account" }, [
      _c("div", { staticClass: "qr-code" }),
      _vm._v(" "),
      _c("p", [_vm._v("问卷网公众号")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "line" }, [
      _c("a", { attrs: { href: "/register/protocol/" } }, [
        _vm._v("服务协议    ")
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "/about/ystk/", target: "_blank" } }, [
        _vm._v("隐私政策    ")
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "/about/disclaimer/", target: "_blank" } }, [
        _vm._v("免责声明    ")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mobile-line" }, [
      _c("div", { staticClass: "line" }, [_vm._v("ICP证：合字B2-20220130")]),
      _vm._v(" "),
      _c("div", { staticClass: "line" }, [
        _c(
          "a",
          { attrs: { href: "https://beian.miit.gov.cn/", target: "_blank" } },
          [_vm._v("沪ICP备10013448号-25")]
        )
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href:
              "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402000149",
            target: "_blank"
          }
        },
        [_vm._v("沪公网安备31010402000149号")]
      )
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mobile-line" }, [
      _c("div", { staticClass: "line" }, [
        _c(
          "a",
          { attrs: { href: "http://www.shjbzx.cn/", target: "_blank" } },
          [_vm._v("上海市互联网违法和不良信息举报中心")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "line" }, [
        _c("a", { attrs: { href: "javascript:void(0);" } }, [
          _vm._v("扫黑除恶举报")
        ])
      ])
    ])
  }
]
render._withStripped = true


// CONCATENATED MODULE: ./packages/common-footer/src/index.vue?vue&type=template&id=42163b76&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui/lib/theme-chalk/tooltip.css"
var tooltip_css_ = __webpack_require__(214);

// EXTERNAL MODULE: external "@wenjuan/ui/lib/tooltip"
var tooltip_ = __webpack_require__(192);
var tooltip_default = /*#__PURE__*/__webpack_require__.n(tooltip_);

// EXTERNAL MODULE: ./src/assets/js/header-config.js
var header_config = __webpack_require__(57);

// EXTERNAL MODULE: ./src/assets/js/utils/tools.js
var tools = __webpack_require__(5);

// EXTERNAL MODULE: ./src/assets/js/utils/qiyuKF.js
var qiyuKF = __webpack_require__(177);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/common-footer/src/index.vue?vue&type=script&lang=js&





/* harmony default export */ var srcvue_type_script_lang_js_ = ({
  name: "CommonFooter",
  components: {
    wjTooltip: tooltip_default.a
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    // 是否登入
    login: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pcConfigOne: header_config["f" /* pcFooterConfigOne */],
      pcConfigTwo: header_config["g" /* pcFooterConfigTwo */],
      mobileConfig: header_config["d" /* mobileFooterConfig */],
      currentYear: new Date().getFullYear(),
      isMobileEnd: false
    };
  },
  watch: {
    login(val) {
      Object(qiyuKF["a" /* initQiyuKF */])(null, val);
    }
  },
  mounted() {
    Object(qiyuKF["a" /* initQiyuKF */])(null, this.login);
    this.initDomAndBom();
  },
  methods: {
    gotoQiyu() {
      window.ysf && window.open(window.ysf("url"));
    },
    initDomAndBom() {
      this.isMobileEnd = Object(tools["b" /* distinguishUserAgentUtils */])().isMobile;
      document.addEventListener("click", e => {
        if (e.target.id !== "trigger-tooltips") {
          if (!(!this.isMobile && !this.isMobileEnd)) {
            document.getElementById("moible-footer-ad-cooperation") && (document.getElementById("moible-footer-ad-cooperation").style.display = "none");
          }
        }
      });
    },
    showTooltip() {
      document.getElementById("moible-footer-ad-cooperation").style.display = "block";
    }
  }
});
// CONCATENATED MODULE: ./packages/common-footer/src/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var common_footer_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/common-footer/src/index.vue?vue&type=style&index=0&id=42163b76&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/common-footer/src/index.vue?vue&type=style&index=0&id=42163b76&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/common-footer/src/index.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  common_footer_srcvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "42163b76",
  null
  
)

/* harmony default export */ var src = (component.exports);
// CONCATENATED MODULE: ./packages/common-footer/index.js

src.install = function (Vue) {
  Vue.component(src.name, src);
};
/* harmony default export */ var common_footer = __webpack_exports__["default"] = (src);

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hideMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isNotEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return distinguishUserAgentUtils; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return loadJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return urlDelP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataURLtoFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return downloadGenerateQRCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUserAgentInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isWxMiniApp; });
/* unused harmony export insertHTML */
// 获取url链接中的参数
function getQueryString(name) {
  let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i");
  const r = source.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

// 手机打*号
function hideMobile(mobile) {
  if (!mobile) return "";
  return `${mobile.substr(0, 3)}****${mobile.substr(-4)}`;
}

// 判断变量是否为空
function isNotEmpty(obj) {
  if (typeof obj === "undefined" || obj == null) {
    return false;
  }
  if (typeof obj === "function") {
    return true;
  }
  if (obj.constructor == Number) {
    if (obj) {
      return true;
    }
    return false;
  }
  if (typeof obj === "string") {
    if (obj !== "") {
      return true;
    }
    return false;
  }
  return Object.keys(obj).length > 0;
}

// 区分浏览器类型
function distinguishUserAgentUtils(userAgent) {
  if (typeof window !== "undefined") {
    var _window, _window$navigator, _window2;
    const ua = userAgent || ((_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent.toLowerCase());
    const isTouTiaoMiniApp = ua.includes("toutiaomicroapp");
    const isQQMiniApp = ua.includes("qq") && ua.includes("miniprogram") && !ua.includes("micromessenger");
    const isBaiduMiniApp = ua.includes("baiduboxapp") && ua.includes("swan");
    const isWeixinMiniApp = ua.includes("micromessenger") && ua.includes("miniprogram");
    return {
      isEdge: ua.includes("Edge"),
      isFF: ua.includes("Firefox"),
      isOpera: ua.includes("Opera"),
      isBB: ua.includes("BlackBerry"),
      isChrome: ua.includes("Chrome"),
      isMaxthon: ua.includes("Maxthon"),
      isFeishu: ua.includes("Lark/"),
      isIos: /(iPhone|iPad|iPod|iOS)/i.test(ua),
      isSafari: ua.includes("Safari") && !ua.includes("Chrome"),
      isIE: !!window.ActiveXObject || "ActiveXObject" in window,
      isMobile: /(iPad|iPhone|iPod|Opera Mini|Android.*Mobile|NetFront|PSP|BlackBerry|Windows Phone)/gi.test(ua),
      isWeixin: ua.match(/MicroMessenger/i) === "micromessenger",
      isWeibo: ua.match(/WeiBo/i) === "weibo",
      isWxwork: ua.match(/wxwork/i) === "wxwork",
      isQQ: ua.match(/QQ/i) === "qq",
      isIosApp: ua.includes("wenjuan/") && /(iPhone|iPad|iPod|iOS)/i.test(ua),
      isApp: ua.includes("wenjuan/") || ua.includes("android_app/"),
      isTeacherApp: ua.includes("campusteacher/") || ua.includes("campusstudent/"),
      isHarmony: ua.includes("harmony_wenjuanwrap"),
      isAndroidApp: ua.includes("android_app/"),
      isAndroid: (ua.match(/android/i) === "android" || ua.match(/adr/i) === "adr") && ua !== "android_app/1.0.0",
      // ios android 客户端
      isNative: ua.match(/android_app\//i) === "android_app/" || ua.match(/wenjuan\//i) === "wenjuan/",
      isBaiying: ua.includes("baiying"),
      isDingding: ua.includes("DingTalk"),
      isTencentWemeet: ua.includes("tencent_wemeet"),
      isMac: /macintosh|mac os x/i.test(ua),
      isPWA: (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.matchMedia("(display-mode: minimal-ui)").matches,
      isUc: ua.includes("ucbrowser"),
      isCloudpay: ua.includes("unionpay"),
      isDingTalk: ua.includes("dingtalk"),
      isTencentMeeting: ua.includes("tencent_wemeet"),
      isQuark: ua.includes("quark"),
      isTouTiaoMiniApp,
      isQQMiniApp,
      isBaiduMiniApp,
      isWeixinMiniApp,
      isMiniApp: isTouTiaoMiniApp || isQQMiniApp || isBaiduMiniApp || isWeixinMiniApp
    };
  }
  return {};
}

// js中动态加载script，并在load后触发cb
function loadJS(url, callback) {
  const script = document.createElement("script");
  const fn = callback || function () {};
  script.type = "text/javascript";
  // IE
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState == "loaded" || script.readyState == "complete") {
        script.onreadystatechange = null;
        fn();
      }
    };
  } else {
    // 其他浏览器
    script.onload = function () {
      fn();
    };
  }
  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}

// 删除URL上某个参数
function urlDelP(url, name) {
  const urlArr = url.split("?");
  if (urlArr.length > 1 && urlArr[1].indexOf(name) > -1) {
    const query = urlArr[1];
    const obj = {};
    const arr = query.split("&");
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split("=");
      obj[arr[i][0]] = arr[i][1];
    }
    delete obj[name];
    const querys = JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
    let searchs = "";
    if (querys) {
      searchs = `?${querys}`;
    }
    const urlte = urlArr[0] + searchs;
    return urlte;
  }
  return url;
}
/**
 * 将base64转换为文件
 * @param {String} dataUrl 图片地址
 * @param {String} imgType 图片类型 传png,jpg等 而不是image/png
 * @return blob文件
 */
function dataURLtoFile(dataUrl, imgType) {
  var _arr$;
  // 替换base64图片的图片类型
  if (imgType) {
    const types = dataUrl.match(/data:image[^;]*;base64,/gi);
    types.forEach(type => {
      dataUrl = dataUrl.replace(new RegExp(`${type}`, "g"), `data:image/${imgType};base64,`);
    });
  }
  const arr = dataUrl.split(",");
  const reg = (_arr$ = arr[0]) === null || _arr$ === void 0 ? void 0 : _arr$.match(/:(.*?);/);
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: reg ? reg[1] : ""
  });
}

// 前端生成二维码-下载二维码
function downloadGenerateQRCode(url) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "图片";
  if (window.navigator.msSaveOrOpenBlob) {
    // ie
    const bstr = atob(url.split(",")[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const blob = new Blob([u8arr]);
    window.navigator.msSaveOrOpenBlob(blob, `${name}.png`);
  } else {
    // 非ie
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", `${name}.png`);
    a.click();
  }
}
function getUserAgentInfo() {
  const {
    userAgent
  } = navigator;
  let version;
  if (/opera/i.test(userAgent) || /OPR/i.test(userAgent)) {
    version = getVersion(userAgent, "OPR/(\\d+\\.+\\d+)");
    return ["Opera", version];
  }
  if (/compatible/i.test(userAgent) && /MSIE/i.test(userAgent)) {
    version = getVersion(userAgent, "MSIE (\\d+\\.+\\d+)");
    return ["IE", version];
  }
  if (/Edg/i.test(userAgent)) {
    version = getVersion(userAgent, "Edg/(\\d+\\.+\\d+)");
    return ["Edge", version];
  }
  if (/Firefox/i.test(userAgent)) {
    version = getVersion(userAgent, "Firefox/(\\d+\\.+\\d+)");
    return ["Firefox", version];
  }
  if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) {
    version = getVersion(userAgent, "Version/(\\d+\\.+\\d+)");
    return ["Safari", version];
  }
  if (/Chrome/i.test(userAgent) && /Safari/i.test(userAgent)) {
    version = getVersion(userAgent, "Chrome/(\\d+\\.+\\d+)");
    return ["Chrome", version];
  }
  if (userAgent.includes("Trident") || userAgent.includes("MSIE")) {
    return ["IE", "any"];
  }
}
function getVersion(userAgent, reg) {
  const reBrowser = new RegExp(reg);
  reBrowser.test(userAgent);
  return parseInt(RegExp.$1);
}

// 判断是否是小程序环境
function isWxMiniApp() {
  try {
    var _window3, _window3$navigator, _window3$navigator$us;
    const ua = (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$navigator = _window3.navigator) === null || _window3$navigator === void 0 ? void 0 : (_window3$navigator$us = _window3$navigator.userAgent) === null || _window3$navigator$us === void 0 ? void 0 : _window3$navigator$us.toLowerCase();
    const uaIsWxMiniApp = ua.includes("micromessenger") && ua.includes("miniprogram");
    if (uaIsWxMiniApp) return true;
    const appname = getQueryString("appname");
    if (appname === "wj-miniapp") return true;
    if (window.__wxjs_environment === "miniprogram") return true;
  } catch (error) {}
}

// insert HTML
function insertHTML(html, editor) {
  if (window.getSelection) {
    // IE9 and non-IE
    const sel = window.getSelection();
    if (editor && sel.focusNode !== editor && sel.focusNode.parentNode !== editor) {
      editor.innerHTML += html;
      return;
    }
    if (sel.getRangeAt && sel.rangeCount) {
      let range = sel.getRangeAt(0);
      range.deleteContents();
      const el = document.createElement("div");
      el.innerHTML = html;
      const frag = document.createDocumentFragment();
      let node = el.firstChild;
      let lastNode;
      while (node) {
        lastNode = frag.appendChild(node);
        node = el.firstChild;
      }
      range.insertNode(frag);

      // Preserve the selection
      if (lastNode) {
        range = range.cloneRange();
        range.setStartAfter(lastNode);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  } else if (document.selection && document.selection.type !== "Control") {
    // IE < 9
    document.selection.createRange().pasteHTML(html);
  }
}

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUserPackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return httpGetStroeBaseInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sendPayClue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return httpDeployCurrentRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deloyLogout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return httpLoginAsAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUnfilledAnswerList; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

let request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
if (!request || !request.get || !request.post) {
  console.log("%c项目没有注入http封装", "color:red;");
}

// 获取用户信息
function getUserInfo(data) {
  // data?.unInterceptors = true;
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get(`/member/api/info/simple/`, data);
}
function getUserPackage() {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/plugin/api/v1/member_package/info/");
}

/**
 * 获取商户基础详细
 * @param {*}
 */
function httpGetStroeBaseInfo() {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/member/api/merchant_info/", {});
}

// 发送付费套餐线索
function sendPayClue(data) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.post("/api/cms_pay_clue/pay_clue/create/", data);
}

/**
 * 获取部署版用户角色
 * @returns
 */
function httpDeployCurrentRole(params) {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/api/deployment/member/role/", params);
}

/**
 * 部署版退出登录
 * @returns
 */
function deloyLogout() {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/api/deployment/member/logout/");
}

// 已登录用户尝试直接登入后台管理页面
function httpLoginAsAdmin() {
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/api/deployment/member/login_as_admin/");
}

// 这个接口稀烂的很，page_size = 1 直接404、422
const getUnfilledAnswerList = function () {
  let page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  let page_size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
  return request.get("/api/sample_user/unfilled_answer_list/", {
    page,
    page_size
  });
};

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return menuList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return menuConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return innerFoundMenu; });
/* unused harmony export helpMenu */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return mobileMenuList; });
/* unused harmony export pcFooterConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return pcFooterConfigOne; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return pcFooterConfigTwo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mobileFooterConfig; });
const menuList = {
  product: {
    text: "产品介绍",
    key: "product",
    type: "sub",
    hideInFeiShu: true,
    hideInDingding: true,
    hideInBaiying: true,
    subMenu: [{
      text: "场景",
      menu: [{
        key: "ai",
        href: "/ai/",
        text: "问问AI"
      }, {
        key: "survey",
        href: "/survey/",
        text: "问卷调查"
      }, {
        key: "satisfaction",
        href: "/satisfaction/",
        text: "满意度调查"
      }, {
        key: "assess",
        href: "/assess/",
        text: "考试测评"
      }, {
        key: "form",
        href: "/form/",
        text: "在线收集表单"
      }, {
        key: "vote",
        href: "/vote/",
        text: "投票评选",
        label: "new-tip-icon"
      }, {
        key: "pay",
        href: "/pay/",
        text: "在线收款"
      }, {
        key: "appraise",
        href: "/appraise/",
        text: "360度评估"
      }, {
        key: "knowledge",
        href: "/knowledge/",
        text: "知识竞赛"
      }]
    }, {
      text: "版本",
      menu: [
      // {
      //     key: "senior_user",
      //     href: "/senior_user/",
      //     text: "版本定价"
      // },
      {
        key: "app",
        href: "/app/",
        text: "问卷网APP"
      }, {
        key: "campus",
        href: "https://campus.wenjuan.com/",
        target: "_blank",
        text: "问卷网教师版"
      }

      // {
      //     text: "企业微信版",
      //     key: "wxbusiness",
      //     href: "/wxbusiness/"
      // }
      ]
    }]
  },

  list: {
    text: "项目",
    key: "list",
    href: "/list/"
  },
  lib: {
    text: "免费模板",
    key: "lib",
    href: "/lib/",
    hideInFeiShu: true,
    hideInDingding: true,
    hideInBaiying: true
  },
  libs: {
    text: "模板",
    key: "lib",
    href: "/lib/",
    target: "_blank",
    hideInFeiShu: true,
    hideInDingding: true,
    hideInBaiying: true
  },
  collectPost: {
    text: "样本收集",
    key: "collectPost",
    href: "/collect_post/",
    hideInFeiShu: true,
    hideInDingding: true,
    hideInBaiying: true
  },
  contact: {
    text: "联系人",
    key: "contact",
    href: "/contact/list/"
  },
  found: {
    text: "发现",
    type: "sub",
    key: "found",
    hideInFeiShu: true,
    hideInDingding: true,
    hideInBaiying: true,
    subMenu: [{
      text: "内容资源",
      menu: [{
        text: "考试题库",
        key: "question_square",
        href: "/question_square/",
        label: "new-tip-icon"
        // hideInFeiShu: true
      }, {
        text: "经典测试",
        key: "classical_test",
        href: "/classical_test/"
      }, {
        text: "调研专栏",
        key: "content_center",
        href: "/casecenter/articles/"
      }]
    }, {
      text: "师生服务",
      menu: [{
        text: "互答广场",
        key: "answer_square",
        href: "/discover/answer_square/",
        hideInFeiShu: true
      }, {
        text: "论文查重",
        key: "paper_check",
        href: "/station/paper/check/",
        hideInFeiShu: true
      }, {
        text: "师生专题",
        key: "topic",
        href: "/topic/campus/",
        target: "_blank",
        hideInFeiShu: true
      }]
    }]
  },
  plugin: {
    text: "应用",
    key: "plugin",
    href: "/plugin/",
    hideInFeiShu: true,
    hideInDingding: true,
    hideInBaiying: true
  },
  enterprise: {
    text: "企业服务",
    key: "enterprise",
    type: "sub",
    hideInFeiShu: true,
    hideInDingding: true,
    hideInBaiying: true,
    subMenu: [{
      text: "企业应用",
      menu: [{
        text: "企业版",
        key: "ent",
        href: "/pro/"
      }, {
        text: "倍市得CEM",
        key: "bestcem",
        href: "https://www.bestcem.com/?utm_source=wenjuan_top",
        label: "recommend-tip-icon",
        target: "_blank"
      }, {
        text: "SPSSPRO",
        key: "sps",
        href: "https://www.spsspro.com/?utm_source=wenjuan_top",
        label: "new-tip-icon",
        target: "_blank"
      }, {
        text: "问卷网-开放平台",
        key: "open",
        href: "https://open.wenjuan.com/",
        target: "_blank"
      }]
    }, {
      text: "专业服务",
      menu: [{
        text: "专业调研服务",
        key: "biz",
        href: "http://biz.wenjuan.com/",
        target: "_blank"
      }, {
        text: "专业样本服务",
        key: "collectPost",
        href: "/sample_service/"
      }, {
        text: "商务合作",
        key: "bd",
        href: "/bd/"
      }, {
        text: "私有化部署",
        key: "private",
        href: "/senior_user/#private"
      }]
    }]
  },
  senior_user: {
    key: "senior_user",
    href: "/senior_user/",
    text: "版本定价"
  },
  merchant: {
    text: "收款",
    key: "merchant",
    href: ""
  },
  innerCollectPost: {
    text: "样本收集",
    key: "innerCollectPost",
    href: "/inner_collect_post",
    subTextConf: {
      subText: "NEW",
      style: {
        color: "white",
        background: "#FF6D56"
      },
      isHide: false
    }
  }
};
const menuConfig = {
  inner: ["list", "libs", "contact", "merchant", "plugin", "innerCollectPost"],
  index: ["product", "lib", "collectPost", "enterprise", "senior_user", "found"],
  feishu: ["list", "contact"],
  dingding: ["list", "contact"],
  baiying: ["list", "contact"]
};
const innerFoundMenu = [
// {
//     title: "首页",
//     desc: "问卷网官网",
//     href: "/",
//     target: "_blank"
// },
{
  title: "产品介绍",
  desc: "8种用途介绍",
  subMenu: [{
    text: "场景",
    key: "scene",
    menu: [{
      key: "survey",
      href: "/survey/",
      text: "问卷调查",
      desc: "丰富模板·简单易用",
      target: "_blank"
    }, {
      key: "satisfaction",
      href: "/satisfaction/",
      text: "满意度调查",
      target: "_blank",
      desc: "专业的维度报告"
    }, {
      key: "assess",
      href: "/assess/",
      text: "考试测评",
      target: "_blank",
      desc: "简单高效的考试助手"
    }, {
      key: "form",
      href: "/form/",
      text: "在线收集表单",
      target: "_blank",
      desc: "信息收集从此高效"
    }, {
      key: "vote",
      href: "/vote/",
      text: "投票评选",
      label: "new-tip-icon",
      target: "_blank",
      desc: "轻松创建大型投票评选"
    }, {
      key: "knowledge",
      href: "/knowledge/",
      text: "知识竞赛",
      target: "_blank",
      desc: "支持大型竞赛活动"
    }, {
      key: "pay",
      href: "/pay/",
      text: "在线收款",
      target: "_blank",
      desc: "免费入驻·安全快速"
    }, {
      key: "appraise",
      href: "/appraise/",
      text: "360度评估",
      target: "_blank",
      desc: "人才测评助手"
    }]
  }
  // {
  //     text: "版本",
  //     key: "version",
  //     menu: [
  //         {
  //             key: "senior_user",
  //             href: "/senior_user/",
  //             text: "版本定价",
  //             target: "_blank",
  //             desc: "高级版·企业版·旗舰版"
  //         },
  //         {
  //             key: "app",
  //             href: "/app/",
  //             text: "问卷网APP",
  //             target: "_blank",
  //             desc: "随时随地查看数据"
  //         }
  //     ]
  // }
  ]
}, {
  title: "企业服务",
  desc: "体验·数据分析·数据对接",
  subMenu: [{
    text: "企业应用",
    key: "entApp",
    menu: [
    // {
    //     text: "问卷网·企业版",
    //     key: "ent",
    //     target: "_blank",
    //     href: "/pro/",
    //     target: "_blank",
    //     desc: "团队协作·品牌露出"
    // },
    {
      text: "倍市得CEM",
      key: "bestcem",
      href: "https://www.bestcem.com/?utm_source=wenjuan_inner_nav",
      label: "recommend-tip-icon",
      target: "_blank",
      desc: "体验管理·倍市可得"
    }, {
      text: "SPSSPRO",
      key: "sps",
      href: "https://www.spsspro.com/?utm_source=wenjuan_inner_nav",
      label: "new-tip-icon",
      target: "_blank",
      desc: "数据分析神器"
    }, {
      text: "专业调研服务",
      key: "biz",
      href: "http://biz.wenjuan.com/",
      target: "_blank",
      desc: "全方位市场研究与洞察"
    }, {
      text: "专业样本服务",
      key: "collectPost",
      href: "/sample_service/",
      target: "_blank",
      desc: "精准快速的问卷样本收集"
    }, {
      text: "商务合作",
      key: "bd",
      href: "/bd/",
      target: "_blank",
      desc: "品牌合作·VIP服务"
    }, {
      text: "开放平台",
      key: "open",
      href: "https://open.wenjuan.com/",
      target: "_blank",
      desc: "数据对接更轻松"
    }]
  }
  // {
  //     text: "专业服务",
  //     key: "service",
  //     menu: [
  //         {
  //             text: "专业调研服务",
  //             key: "biz",
  //             href: "http://biz.wenjuan.com/",
  //             target: "_blank",
  //             desc: "全方位市场研究与洞察"
  //         },
  //         {
  //             text: "专业样本服务",
  //             key: "collectPost",
  //             href: "/sample_service/",
  //             target: "_blank",
  //             desc: "精准快速的问卷样本收集"
  //         },
  //         {
  //             text: "商务合作",
  //             key: "bd",
  //             href: "/bd/",
  //             target: "_blank",
  //             desc: "品牌合作·VIP服务"
  //         }
  //     ]
  // }
  ]
}, {
  title: "内容资源",
  desc: "题库·经典测评·调研专栏",
  subMenu: [{
    text: "",
    key: "resource",
    menu: [{
      text: "考试题库",
      key: "question_square",
      href: "/question_square/",
      label: "new-tip-icon",
      target: "_blank",
      desc: "搜题组题更简单"
      // hideInFeiShu: true
    }, {
      text: "经典测试",
      key: "classical_test",
      href: "/classical_test/",
      target: "_blank",
      desc: "职业·人格·趣味测试"
    }, {
      text: "调研专栏",
      key: "content_center",
      href: "/casecenter/articles/",
      target: "_blank",
      desc: "学习调研好帮手"
    }]
  }]
}, {
  title: "师生服务",
  desc: "互答·论文查重·模板·素养测评",
  subMenu: [{
    text: "",
    key: "tasServer",
    menu: [{
      text: "问卷网教师版",
      key: "campus",
      href: "https://campus.wenjuan.com/",
      desc: " 老师的教学教务好帮手",
      target: "_blank",
      hideInFeiShu: true
    }, {
      text: "样本收集",
      key: "collectPost",
      href: "/collect_post/",
      desc: " 低价·收集速度快",
      target: "_blank",
      hideInFeiShu: true
    }, {
      text: "互答广场",
      key: "answer_square",
      href: "/discover/answer_square/",
      desc: "大学生免费样本收集",
      target: "_blank",
      hideInFeiShu: true
    }, {
      text: "论文查重",
      key: "paper_check",
      href: "/station/paper/check/",
      desc: "最高10万字免费查询",
      target: "_blank",
      hideInFeiShu: true
    }, {
      text: "师生专题",
      key: "topic",
      href: "/topic/campus/",
      target: "_blank",
      desc: "学生老师常用模板",
      hideInFeiShu: true
    }]
  }]
}, {
  title: "问卷网公众号",
  desc: "手机查看数据更轻松",
  showQrCode: true // 展示问卷网公众号
}];

const helpMenu = [{
  title: "问卷网官网",
  desc: "",
  href: "/"
}, {
  title: "问卷网官网",
  desc: "",
  href: "/"
}];
const mobileMenuList = [{
  text: "产品介绍",
  key: "product",
  showMenu: false,
  subMenu: [{
    key: "ai",
    href: "/ai/",
    text: "问问AI"
  }, {
    key: "survey",
    href: "/survey/",
    text: "问卷调查"
  }, {
    key: "satisfaction",
    href: "/satisfaction/",
    text: "满意度调查"
  }, {
    key: "assess",
    href: "/assess/",
    text: "考试测评"
  }, {
    key: "form",
    href: "/form/",
    text: "在线收集表单"
  }, {
    key: "vote",
    href: "/vote/",
    text: "投票评选",
    label: "new-tip-icon"
  }, {
    key: "knowledge",
    href: "/knowledge/",
    text: "知识竞赛"
  }, {
    key: "appraise",
    href: "/appraise/",
    text: "360评估"
  }, {
    text: "样本收集",
    key: "collectPost",
    href: "/collect_post/"
  }, {
    key: "senior_user",
    href: "/senior_user/",
    text: "版本定价"
  }, {
    key: "app",
    href: "/app/",
    text: "下载APP"
  }, {
    key: "campus",
    href: "https://campus.wenjuan.com/",
    text: "问卷网教师版"
  }]
}, {
  text: "内容资源",
  key: "resource",
  showMenu: false,
  subMenu: [{
    text: "免费模板",
    key: "lib",
    href: "/lib/"
  }, {
    text: "考试题库",
    key: "question_square",
    href: "/question_square/",
    label: "new-tip-icon",
    desc: "搜题组题更简单"
    // hideInFeiShu: true
  }, {
    text: "经典测试",
    key: "classical_test",
    href: "/classical_test/",
    desc: "职业·人格·趣味测试"
  }, {
    text: "调研专栏",
    key: "content_center",
    href: "/casecenter/articles/",
    desc: "学习调研好帮手"
  }, {
    text: "帮助中心",
    key: "help_center",
    href: "/helpcenter/"
  }]
}, {
  text: "企业服务",
  key: "enterprise",
  showMenu: false,
  subMenu: [{
    text: "企业版",
    key: "ent",
    href: "/pro/"
  }, {
    text: "倍市得CEM",
    key: "bestcem",
    href: "https://www.bestcem.com/?utm_source=wenjuan_top",
    label: "recommend-tip-icon",
    target: "_blank"
  }, {
    text: "SPSSPRO",
    key: "sps",
    href: "https://www.spsspro.com/?utm_source=wenjuan_top",
    label: "new-tip-icon",
    target: "_blank"
  }, {
    text: "专业调研服务",
    key: "biz",
    href: "http://biz.wenjuan.com/"
  }]
}];
const pcFooterConfig = [{
  text: "使用场景",
  key: "product",
  type: "sub",
  subMenu: [{
    key: "survey",
    href: "/survey/",
    text: "问卷调查"
  }, {
    key: "satisfaction",
    href: "/satisfaction/",
    text: "满意度调查"
  }, {
    key: "assess",
    href: "/assess/",
    text: "考试测评"
  }, {
    key: "form",
    href: "/form/",
    text: "在线收集表单"
  }, {
    key: "vote",
    href: "/vote/",
    text: "投票评选",
    label: "new-tip-icon"
  }, {
    key: "pay",
    href: "/pay/",
    text: "在线收款"
  }, {
    key: "appraise",
    href: "/appraise/",
    text: "360度评估"
  }]
}, {
  text: "企业服务",
  key: "enterprise",
  type: "sub",
  subMenu: [{
    text: "企业版",
    key: "ent",
    href: "/pro/"
  }, {
    text: "SPSSPRO",
    key: "sps",
    href: "https://www.spsspro.com/?utm_source=wenjuan_footer",
    label: "new-tip-icon",
    target: "_blank"
  }, {
    text: "倍市得CEM",
    key: "bestcem",
    href: "https://www.bestcem.com/?utm_source=wenjuan_footer",
    label: "recommend-tip-icon",
    target: "_blank"
  }, {
    text: "开放平台",
    key: "open",
    href: "https://open.wenjuan.com/",
    target: "_blank"
  }, {
    text: "专业调研服务",
    key: "biz",
    href: "http://biz.wenjuan.com/",
    target: "_blank"
  }, {
    text: "专业样本服务",
    key: "collectPost",
    href: "/sample_service/"
  }]
}, {
  text: "资源",
  key: "resource",
  subMenu: [{
    text: "免费模板",
    key: "lib",
    href: "/lib/"
  }, {
    text: "考试题库",
    key: "question_square",
    href: "/question_square/",
    label: "new-tip-icon"
    // hideInFeiShu: true
  }, {
    text: "经典测试",
    key: "classical_test",
    href: "/classical_test/"
  }, {
    text: "调研专栏",
    key: "content_center",
    href: "/casecenter/articles/"
  }, {
    text: "答题赚钱",
    href: "https://www.idiaoyan.com/desktop_login?type=quick&id=&source=263453&plan=&device=&suid=",
    target: "_blank"
  }, {
    text: "帮助中心",
    key: "help_center",
    href: "/helpcenter/"
  }]
}, {
  text: "版本",
  key: "version",
  hideInMobile: true,
  subMenu: [{
    key: "senior_user",
    href: "/senior_user/",
    text: "版本定价"
  }, {
    key: "app",
    href: "/app/",
    text: "问卷网APP"
  }, {
    text: "企业微信版",
    href: "/wxbusiness/",
    target: "_blank"
  }, {
    text: "钉钉版",
    href: "https://appcenter.dingtalk.com/detail.html?goodsCode=DT_GOODS_881650260477337&sig=919627509847c6e2112690d5168d19e2",
    target: "_blank"
  }, {
    text: "飞书版",
    href: "https://app.feishu.cn/app/cli_9c10807b13b01108",
    target: "_blank"
  }, {
    text: "腾讯会议版",
    href: "https://meeting.tencent.com/marketplace/support-collect-detail?sdk_id=19170189429&page_channel_source=webmarket",
    target: "_blank"
  }, {
    text: "问卷网教师版",
    href: "https://campus.wenjuan.com/",
    target: "_blank"
  }]
}, {
  text: "师生服务",
  key: "teacherStudent",
  hideInMobile: true,
  subMenu: [{
    text: "样本收集",
    key: "collectPost",
    href: "/collect_post/"
  }, {
    text: "互答广场",
    key: "answer_square",
    href: "/discover/answer_square/"
  }, {
    text: "论文查重",
    key: "paper_check",
    href: "/station/paper/check/"
  }, {
    text: "校园专题",
    href: "/topic/campus/",
    target: "_blank"
  }]
}, {
  text: "公司",
  key: "company",
  subMenu: [{
    text: "关于我们",
    href: "/about/"
  }, {
    text: "合作伙伴",
    href: "/about/partner/"
  }, {
    text: "商务合作",
    href: "/bd/"
  }, {
    text: "咨询反馈",
    href: "/about/zxzx/"
  }]
}];
const pcFooterConfigOne = [{
  text: "使用场景",
  key: "product",
  type: "sub",
  subMenu: [{
    key: "survey",
    href: "/survey/",
    text: "问卷调查"
  }, {
    key: "satisfaction",
    href: "/satisfaction/",
    text: "满意度调查"
  }, {
    key: "assess",
    href: "/assess/",
    text: "考试测评"
  }, {
    key: "form",
    href: "/form/",
    text: "在线收集表单"
  }, {
    key: "vote",
    href: "/vote/",
    text: "投票评选",
    label: "new-tip-icon"
  }, {
    key: "pay",
    href: "/pay/",
    text: "在线收款"
  }, {
    key: "appraise",
    href: "/appraise/",
    text: "360度评估"
  }]
}, {
  text: "企业服务",
  key: "enterprise",
  type: "sub",
  subMenu: [{
    text: "企业版",
    key: "ent",
    href: "/pro/"
  }, {
    text: "SPSSPRO",
    key: "sps",
    href: "https://www.spsspro.com/?utm_source=wenjuan_footer",
    label: "new-tip-icon",
    target: "_blank"
  }, {
    text: "倍市得CEM",
    key: "bestcem",
    href: "https://www.bestcem.com/?utm_source=wenjuan_footer",
    label: "recommend-tip-icon",
    target: "_blank"
  }, {
    text: "开放平台",
    key: "open",
    href: "https://open.wenjuan.com/",
    target: "_blank"
  }, {
    text: "专业调研服务",
    key: "biz",
    href: "http://biz.wenjuan.com/",
    target: "_blank"
  }, {
    text: "专业样本服务",
    key: "collectPost",
    href: "/sample_service/"
  }, {
    text: "人工服务",
    key: "manualService",
    href: "/service/"
  }]
}, {
  text: "资源",
  key: "resource",
  subMenu: [{
    text: "免费模板",
    key: "lib",
    href: "/lib/"
  }, {
    text: "考试题库",
    key: "question_square",
    href: "/question_square/",
    label: "new-tip-icon"
    // hideInFeiShu: true
  }, {
    text: "经典测试",
    key: "classical_test",
    href: "/classical_test/"
  }, {
    text: "调研专栏",
    key: "content_center",
    href: "/casecenter/articles/"
  }, {
    text: "答题赚钱",
    href: "https://www.idiaoyan.com/desktop_login?type=quick&id=&source=263453&plan=&device=&suid=",
    target: "_blank"
  }, {
    text: "帮助中心",
    key: "help_center",
    href: "/helpcenter/"
  }]
}];
const pcFooterConfigTwo = [{
  text: "版本",
  key: "version",
  hideInMobile: true,
  subMenu: [{
    key: "senior_user",
    href: "/senior_user/",
    text: "版本定价"
  }, {
    key: "app",
    href: "/app/",
    text: "问卷网APP"
  }, {
    text: "企业微信版",
    href: "/wxbusiness/",
    target: "_blank"
  }, {
    text: "钉钉版",
    href: "https://appcenter.dingtalk.com/detail.html?goodsCode=DT_GOODS_881650260477337&sig=919627509847c6e2112690d5168d19e2",
    target: "_blank"
  }, {
    text: "飞书版",
    href: "https://app.feishu.cn/app/cli_9c10807b13b01108",
    target: "_blank"
  }, {
    text: "腾讯会议版",
    href: "https://meeting.tencent.com/marketplace/support-collect-detail?sdk_id=19170189429&page_channel_source=webmarket",
    target: "_blank"
  }, {
    text: "问卷网教师版",
    key: "campus",
    href: "https://campus.wenjuan.com/",
    target: "_blank"
  }]
}, {
  text: "师生服务",
  key: "teacherStudent",
  hideInMobile: true,
  subMenu: [{
    text: "样本收集",
    key: "collectPost",
    href: "/collect_post/"
  }, {
    text: "互答广场",
    key: "answer_square",
    href: "/discover/answer_square/"
  }, {
    text: "论文查重",
    key: "paper_check",
    href: "/station/paper/check/"
  }, {
    text: "校园专题",
    href: "/topic/campus/",
    target: "_blank"
  }]
}, {
  text: "公司",
  key: "company",
  subMenu: [{
    text: "关于我们",
    href: "/about/"
  }, {
    text: "广告合作",
    href: "javascript:void(0);",
    type: "tooltips"
  }, {
    text: "商务合作",
    href: "/bd/"
  }, {
    text: "咨询反馈",
    href: "/about/zxzx/"
  }, {
    text: "友情链接",
    href: "/about/partner/"
  }]
}];
const mobileFooterConfig = [{
  text: "使用场景",
  key: "product",
  type: "sub",
  subMenu: [{
    key: "survey",
    href: "/survey/",
    text: "问卷调查"
  }, {
    key: "satisfaction",
    href: "/satisfaction/",
    text: "满意度调查"
  }, {
    key: "assess",
    href: "/assess/",
    text: "考试测评"
  }, {
    key: "form",
    href: "/form/",
    text: "在线收集表单"
  }, {
    key: "vote",
    href: "/vote/",
    text: "投票评选",
    label: "new-tip-icon"
  }, {
    key: "pay",
    href: "/pay/",
    text: "在线收款"
  }, {
    key: "appraise",
    href: "/appraise/",
    text: "360度评估"
  }]
}, {
  text: "企业服务",
  key: "enterprise",
  type: "sub",
  subMenu: [{
    text: "企业版",
    key: "ent",
    href: "/pro/"
  }, {
    text: "SPSSPRO",
    key: "sps",
    href: "https://www.spsspro.com/?utm_source=wenjuan_footer",
    label: "new-tip-icon",
    target: "_blank"
  }, {
    text: "倍市得CEM",
    key: "bestcem",
    href: "https://www.bestcem.com/?utm_source=wenjuan_footer",
    label: "recommend-tip-icon",
    target: "_blank"
  }, {
    text: "开放平台",
    key: "open",
    href: "https://open.wenjuan.com/",
    target: "_blank"
  }, {
    text: "专业调研服务",
    key: "biz",
    href: "http://biz.wenjuan.com/",
    target: "_blank"
  }, {
    text: "专业样本服务",
    key: "collectPost",
    href: "/sample_service/"
  }, {
    text: "人工服务",
    key: "manualService",
    href: "/service/"
  }]
}, {
  text: "资源",
  key: "resource",
  subMenu: [{
    text: "免费模板",
    key: "lib",
    href: "/lib/"
  }, {
    text: "考试题库",
    key: "question_square",
    href: "/question_square/",
    label: "new-tip-icon"
    // hideInFeiShu: true
  }, {
    text: "经典测试",
    key: "classical_test",
    href: "/classical_test/"
  }, {
    text: "调研专栏",
    key: "content_center",
    href: "/casecenter/articles/"
  }, {
    text: "答题赚钱",
    href: "https://www.idiaoyan.com/desktop_login?type=quick&id=&source=263453&plan=&device=&suid=",
    target: "_blank"
  }, {
    text: "帮助中心",
    key: "help_center",
    href: "/helpcenter/"
  }]
}, {
  text: "公司",
  key: "company",
  subMenu: [{
    text: "关于我们",
    href: "/about/"
  }, {
    text: "广告合作",
    href: "javascript:void(0);",
    type: "tooltips"
  }, {
    text: "商务合作",
    href: "/bd/"
  }, {
    text: "友情链接",
    href: "/about/partner/"
  }]
}];

/***/ })

/******/ })["default"];